import { QRCodeCanvas } from 'qrcode.react';
import { AppEnv } from 'utils/accessEnviroment';

import { SvgUse } from '@dnse/ui';

export const DownloadApp = () => {
  const downloadAppLink = `${AppEnv.HOME_URL}/tai-app`;
  return (
    <div className="w-full flex justify-center mt-[20px] mb-[50px]">
      <div className="relative overflow-hidden w-full lg:w-[1120px] flex justify-center bg-[#F6F5F1] rounded -z-10 px-[20px] py-4">
        <div
          className="absolute md:hidden overflow-hidden w-[1000px] -right-10 bottom-0 -z-10"
          style={{
            height: '140px',
            backgroundImage: 'url(/svg/downloadapp-bg.svg)'
          }}
        />
        <div
          className="absolute hidden md:block overflow-hidden w-full left-0 bottom-0 -z-10"
          style={{
            height: '140px',
            backgroundImage: 'url(/svg/downloadapp-bg.svg)'
          }}
        />
        <div className="flex items-center justify-center ">
          <img
            src="/images/dien-thoai-entradex.png"
            alt="entradex-dien-thoai"
            className="h-[92px] w-[113px] md:w-[184px] md:h-[150px]"
          />
          <div className="flex flex-col gap-y-1 h-full justify-center ml-[12px] sm:mr-[24px]">
            <SvgUse id="entradex-by-dnse-logo" className="h-[40px] w-[150px]" />
            <span className="text-base lg:text-2xl font-bold leading-7 text-brand-300">
              MIỄN PHÍ TRỌN ĐỜI
            </span>
            <span className="hidden md:block text-base font-medium">
              giao dịch chứng khoán với Entrade X by DNSE
            </span>
            <span className="md:hidden text-sm font-medium">
              Tiết kiệm phí giao dịch <br />
              <span className="font-bold">150K/100 triệu</span>
            </span>
          </div>
        </div>
        <div className="hidden sm:flex items-center justify-center gap-[12px]">
          <QRCodeCanvas
            size={92}
            value={downloadAppLink}
            level="H"
            bgColor="#ffffff"
            fgColor="#000000"
          />
          <div className="hidden sm:block text-sm font-medium">
            Quét QR <br />
            để tải App
          </div>
        </div>
      </div>
    </div>
  );
};
